import { Registry } from 'miragejs';
import IdentityManager from 'miragejs/identity-manager';
import Schema from 'miragejs/orm/schema';
import { AuthorizationModel, IdentityProviderModel } from './entity.model';

export interface IdentityManagersMap {
  [modelName: string]: IdentityManager;
}

export type AppRegistry = Registry<
  // models
  {
    authorization: typeof AuthorizationModel;
    identityProvider: typeof IdentityProviderModel;
  },
  // factories
  {}
>;
export type AppSchema = Schema<AppRegistry>;

export const MOCK_MODELS = {
  authorization: AuthorizationModel,
  identityProvider: IdentityProviderModel
};
export const MOCK_FACTORIES = {};
